var React = require('react');

function Component (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31.0228 3.80206C30.66 2.4362 29.5914 1.36053 28.2341 0.995473C25.7745 0.332031 15.9112 0.332031 15.9112 0.332031C15.9112 0.332031 6.04803 0.332031 3.58835 0.995473C2.23109 1.36053 1.16213 2.4362 0.799632 3.80206C0.140625 6.27774 0.140625 11.4432 0.140625 11.4432C0.140625 11.4432 0.140625 16.6084 0.799632 19.0844C1.16213 20.4503 2.23109 21.5258 3.58821 21.8912C6.04789 22.5544 15.9111 22.5544 15.9111 22.5544C15.9111 22.5544 25.7744 22.5544 28.234 21.8912C29.5912 21.5259 30.6599 20.4503 31.0227 19.0845C31.6818 16.6085 31.6818 11.4433 31.6818 11.4433C31.6818 11.4433 31.6818 6.27788 31.0227 3.8022","fill":"white","key":0}),React.createElement("path",{"d":"M12.6836 16.1335L20.9272 11.444L12.6836 6.75391V16.1335Z","fill":"black","key":1})]);
}

Component.defaultProps = {"width":"32","height":"23","viewBox":"0 0 32 23","fill":"none"};

module.exports = Component;

Component.default = Component;
